import styled from 'styled-components';

export const DefaultBannerWrapper = styled.div`
  display: flex;
  text-align: center;

  &.is-info {
    background-color: ${props => props.theme.carvana.blue.pastel};
  }

  &.is-warning {
    background-color: ${props => props.theme.carvana.yellow.primary};
  }

  &.is-error {
    background-color: ${props => props.theme.carvana.red.primary};
  }
`;
